import {
    HomeOutlined,
    PlusOutlined,
    MinusOutlined,
    UploadOutlined,
    DeleteOutlined,
    SaveOutlined,
    ArrowLeftOutlined,
} from "@ant-design/icons";
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Divider,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    Switch,
    Table,
    Typography,
    Upload,
    message,
    Checkbox,
    Tooltip,
    Radio,
    Tag,
    Spin,
} from "antd";
import { useState, useRef, useEffect } from "react";
import { rewardAPIWithErrorHandling } from "../../../api/reward/rewardApi";
import { useNavigate, useParams } from "react-router-dom";
import { brand } from "../../../theme/tokens";

const { Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

// ─── Section Header ───────────────────────────────────────────────────────────
function SectionHeader({ emoji, title }) {
    return (
        <div className="flex items-center gap-2 mb-4">
            {emoji && <span className="text-lg">{emoji}</span>}
            <span className="font-semibold text-gray-700 text-sm tracking-wide uppercase">
                {title}
            </span>
        </div>
    );
}

// ─── Image Upload Box ──────────────────────────────────────────────────────────
// function ImageUploadBox({ label, emoji, name, existingUrl }) {
//     const [preview, setPreview] = useState(existingUrl || null);

//     useEffect(() => {
//         setPreview(existingUrl || null);
//     }, [existingUrl]);

//     const handleChange = (info) => {
//         if (info.file.originFileObj) {
//             const url = URL.createObjectURL(info.file.originFileObj);
//             setPreview(url);
//         }
//     };

//     return (
//         <div>
//             <Text className="block mb-2 text-sm font-medium text-gray-600">
//                 {emoji} {label}
//             </Text>
//             <div className="border-2 border-dashed border-gray-200 rounded-lg p-4 bg-gray-50 hover:border-blue-400 transition-colors">
//                 <div className="flex items-center gap-4">
//                     {preview ? (
//                         <img
//                             src={preview}
//                             alt="preview"
//                             className="w-16 h-16 object-cover rounded-lg border"
//                         />
//                     ) : (
//                         <div className="w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center">
//                             <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
//                                 <rect x="3" y="3" width="18" height="18" rx="2" />
//                                 <circle cx="8.5" cy="8.5" r="1.5" />
//                                 <path d="M21 15l-5-5L5 21" />
//                             </svg>
//                         </div>
//                     )}
//                     <Upload
//                         accept="image/*"
//                         showUploadList={false}
//                         beforeUpload={() => false}
//                         onChange={handleChange}
//                         name={name}
//                     >
//                         <Button
//                             icon={<UploadOutlined />}
//                             style={{ backgroundColor: brand.accent, borderColor: brand.accent, color: "#fff", borderRadius: 6 }}
//                         >
//                             Chọn hình ảnh upload
//                         </Button>
//                     </Upload>
//                 </div>
//             </div>
//         </div>
//     );
// }

function ImageUploadBox({ label, emoji, value, onChange, existingUrl }) {
    const [preview, setPreview] = useState(existingUrl || null);

    useEffect(() => {
        setPreview(existingUrl || null);
    }, [existingUrl]);

    const handleBeforeUpload = (file) => {
        // file ở đây là File gốc 100%
        const url = URL.createObjectURL(file);
        setPreview(url);
        onChange?.(file); // ✅ Đẩy File thật lên Form
        return false; // chặn auto-upload
    };

    return (
        <div>
            <Text className="block mb-2 text-sm font-medium text-gray-600">
                {emoji} {label}
            </Text>
            <div className="border-2 border-dashed border-gray-200 rounded-lg p-4 bg-gray-50 hover:border-blue-400 transition-colors">
                <div className="flex items-center gap-4">
                    {preview ? (
                        <img src={preview} alt="preview" className="w-16 h-16 object-cover rounded-lg border" />
                    ) : (
                        <div className="w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
                                <rect x="3" y="3" width="18" height="18" rx="2" />
                                <circle cx="8.5" cy="8.5" r="1.5" />
                                <path d="M21 15l-5-5L5 21" />
                            </svg>
                        </div>
                    )}
                    <Upload
                        accept="image/*"
                        showUploadList={false}
                        // onChange={handleAntChange}
                        beforeUpload={handleBeforeUpload} // ✅ Dùng beforeUpload thay onChange
                        fileList={[]}                // ✅ Controlled, tránh warning
                    >
                        <Button
                            icon={<UploadOutlined />}
                            style={{ backgroundColor: brand.accent, borderColor: brand.accent, color: "#fff", borderRadius: 6 }}
                        >
                            Chọn hình ảnh
                        </Button>
                    </Upload>
                </div>
            </div>
        </div>
    );
}


// ─── Constants ────────────────────────────────────────────────────────────────
const DATA_TYPES = [
    { value: "text", label: "Text" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone (SĐT)" },
    { value: "number", label: "Number" },
    { value: "date", label: "Date" },
    { value: "select", label: "Select" },
    { value: "radio", label: "Radio" },
    { value: "checkbox", label: "Checkbox" },
];

const OPTION_TYPES = ["select", "radio", "checkbox"];

const DELAY_OPTIONS = [
    { value: "1", label: "Sau 1 giờ" },
    { value: "3", label: "Sau 3 giờ" },
    { value: "5", label: "Sau 5 giờ" },
    { value: "10", label: "Sau 10 giờ" },
    { value: "24", label: "Sau 24 giờ" },
    { value: "48", label: "Sau 48 giờ" },
    { value: "72", label: "Sau 72 giờ" },
];

const DEFAULT_LOCKED_NAMES = ["name", "phone"];

// ─── Option Tags Editor ───────────────────────────────────────────────────────
function OptionTagsEditor({ options = [], onChange }) {
    const [inputVal, setInputVal] = useState("");

    const handleAdd = () => {
        const trimmed = inputVal.trim();
        if (!trimmed) return;
        if (options.includes(trimmed)) { message.warning("Giá trị đã tồn tại"); return; }
        onChange([...options, trimmed]);
        setInputVal("");
    };

    const handleRemove = (opt) => {
        onChange(options.filter((o) => o !== opt));
    };

    return (
        <div className="flex flex-col gap-1">
            <div className="flex flex-wrap gap-1 min-h-6">
                {options.map((opt) => (
                    <Tag
                        key={opt}
                        closable
                        onClose={() => handleRemove(opt)}
                        style={{ borderRadius: 4, fontSize: 11 }}
                    >
                        {opt}
                    </Tag>
                ))}
            </div>
            <div className="flex gap-1">
                <Input
                    size="small"
                    placeholder="Thêm giá trị..."
                    value={inputVal}
                    onChange={(e) => setInputVal(e.target.value)}
                    onPressEnter={handleAdd}
                    style={{ fontSize: 12 }}
                />
                <Button size="small" icon={<PlusOutlined />} onClick={handleAdd} />
            </div>
        </div>
    );
}

// ─── Main Component ────────────────────────────────────────────────────────────
export default function RewardFormUpdate() {
    const { id } = useParams(); // lấy id từ URL, e.g. /reward-forms/:id/edit
    const [form] = Form.useForm();
    const [zaloZnsEnabled, setZaloZnsEnabled] = useState(false);
    const [formType, setFormType] = useState("survey");
    const [sendStrategy, setSendStrategy] = useState("immediate");
    const navigate = useNavigate();

    // Loading states
    const [pageLoading, setPageLoading] = useState(true);

    // Image previews from existing data
    const [existingLogo, setExistingLogo] = useState(null);
    const [existingBg, setExistingBg] = useState(null);

    const [formFields, setFormFields] = useState([]);
    const [newFieldType, setNewFieldType] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const fieldCounter = useRef(10); // start high to avoid collisions with loaded data
    const [telcos, setTelcos] = useState([]);
    const [telcoLoading, setTelcoLoading] = useState(false);
    const [telcoRows, setTelcoRows] = useState([{ id: Date.now(), telco: null, package: null }]);
    const [packages, setPackages] = useState({});
    const [packageLoading, setPackageLoading] = useState({});

    const promotionType = Form.useWatch("promotion_type", form);

    // ── Fetch existing record ────────────────────────────────────────────────
    useEffect(() => {
        if (!id) return;
        const loadData = async () => {
            setPageLoading(true);
            try {
                const response = await rewardAPIWithErrorHandling.getById(id);
                const data = response?.data?.data;
                if (!data) throw new Error("Không tìm thấy dữ liệu");

                console.log('data', data)

                // Populate form fields
                form.setFieldsValue({
                    title: data.title,
                    description: data.description,
                    message: data.message,
                    confirm: data.confirm,
                    direct_url: data.direct_url,
                    miniapp_id: data.miniapp_id,
                    template_id: data.template_id || null,
                    oa_zns: data.oa_zns || null,
                    zns: data.zns || false,
                    promotion_type: (data.promotion_type !== 'OTHER') ? data.promotion_type : null,
                    limit_total: data.limit_total,
                    limit_per_day: data.limit_per_day,
                    send_strategy: data.send_strategy || "immediate",
                    schedule_hours: data.schedule_hours,
                });

                // Form type
                setFormType(data.form_type || "survey");

                // ZNS toggle
                setZaloZnsEnabled(!!data.zns);

                // Send strategy
                setSendStrategy(data.send_strategy || "immediate");

                // Images
                if (data.logo) setExistingLogo(data.logo);
                if (data.image_bg) setExistingBg(data.image_bg);

                // // Form fields — ensure locked flag for default fields
                // if (Array.isArray(data.form) && data.form.length > 0) {
                //     const loadedFields = data.form.map((f) => ({
                //         ...f,
                //         id: f.id || `loaded_${f.name}_${Date.now()}`,
                //         locked: DEFAULT_LOCKED_NAMES.includes(f.name),
                //         options: f.options || [],
                //     }));
                //     setFormFields(loadedFields);
                // }

                // // Telco rows — restored after promotionType watch fires
                // if (Array.isArray(data.promotion_payloads) && data.promotion_payloads.length > 0) {
                //     const rows = data.promotion_payloads.map((p) => ({
                //         id: p.id || Date.now() + Math.random(),
                //         telco: p.telco,
                //         package: p.package,
                //     }));
                //     setTelcoRows(rows);
                //     // Store for later use after telcos are loaded
                //     pendingTelcoRows.current = rows;
                // }

                // Form fields — parse nếu là string
                const rawForm = typeof data.form === "string" ? JSON.parse(data.form) : data.form;
                if (Array.isArray(rawForm) && rawForm.length > 0) {
                    const loadedFields = rawForm.map((f) => ({
                        ...f,
                        id: f.id || `loaded_${f.name}_${Date.now()}`,
                        locked: DEFAULT_LOCKED_NAMES.includes(f.name),
                        options: f.options || [],
                    }));
                    setFormFields(loadedFields);
                }

                // Telco rows — parse nếu là string
                const rawPayloads = typeof data.promotion_payloads === "string"
                    ? JSON.parse(data.promotion_payloads)
                    : data.promotion_payloads;

                if (Array.isArray(rawPayloads) && rawPayloads.length > 0) {
                    const rows = rawPayloads.map((p) => ({
                        id: p.id || Date.now() + Math.random(),
                        telco: p.telco,
                        package: p.package,
                    }));
                    setTelcoRows(rows);
                    pendingTelcoRows.current = rows;
                }
            } catch (err) {
                message.error(err.message || "Không thể tải dữ liệu chương trình");
            } finally {
                setPageLoading(false);
            }
        };
        loadData();
    }, [id]);

    // Ref to hold telco rows that need packages loaded after telcos arrive
    const pendingTelcoRows = useRef(null);

    // ── Fetch telcos when promotionType changes ──────────────────────────────
    const fetchTelco = async (type) => {
        setTelcoLoading(true);
        try {
            const response = await rewardAPIWithErrorHandling.getTelcoAll({ type });
            const tmpData = response?.data;
            if (tmpData.success) {
                setTelcos(tmpData?.data || []);
            }
        } catch (error) {
            message.error("Không thể tải danh sách nhà mạng: " + error.message);
        } finally {
            setTelcoLoading(false);
        }
    };

    useEffect(() => {
        if (!promotionType) return;

        fetchTelco(promotionType);

        // Only reset rows if NOT coming from initial load (pending rows exist)
        if (!pendingTelcoRows.current) {
            setTelcoRows([{ id: Date.now(), telco: null, package: null }]);
            setPackages({});
        }
    }, [promotionType]);

    // ── Load packages for existing telco rows after telcos are fetched ───────
    useEffect(() => {
        const pending = pendingTelcoRows.current;
        if (!pending || telcos.length === 0) return;

        // Set the rows from saved data
        setTelcoRows(pending);

        // Fetch packages for each row that has a telco
        pending.forEach((row) => {
            if (row.telco) {
                fetchPackage(row.telco, row.id);
            }
        });

        // Clear pending so future promotionType changes reset normally
        pendingTelcoRows.current = null;
    }, [telcos]);

    const fetchPackage = async (provider, rowId) => {
        setPackageLoading(prev => ({ ...prev, [rowId]: true }));
        try {
            const response = await rewardAPIWithErrorHandling.getPackageAll({
                type: promotionType,
                provider,
            });
            const tmpData = response?.data;
            if (tmpData.success) {
                setPackages(prev => ({ ...prev, [rowId]: tmpData?.data || [] }));
            }
        } catch (error) {
            message.error("Không thể tải gói cước: " + error.message);
        } finally {
            setPackageLoading(prev => ({ ...prev, [rowId]: false }));
        }
    };

    // ── Telco helpers ─────────────────────────────────────────────────────────
    const getUsedTelcos = (excludeRowId) =>
        telcoRows.filter(r => r.id !== excludeRowId && r.telco).map(r => r.telco);

    const canAddTelcoRow = telcos.length === 0 || telcoRows.length < telcos.length;

    // ── Form Fields CRUD ────────────────────────────────────────────────────────
    const handleAddField = () => {
        if (!newFieldType) { message.warning("Vui lòng chọn kiểu dữ liệu"); return; }
        const newField = {
            id: Date.now(),
            question: "",
            note: "",
            name: `question${fieldCounter.current++}`,
            dataType: newFieldType,
            required: false,
            locked: false,
            options: [],
        };
        setFormFields((prev) => [...prev, newField]);
        setNewFieldType(null);
    };

    const handleRemoveField = (id) => {
        setFormFields((prev) => prev.filter((f) => f.id !== id));
    };

    const handleFieldChange = (id, key, val) => {
        setFormFields((prev) => prev.map((f) => (f.id === id ? { ...f, [key]: val } : f)));
    };

    const handleTelcoChange = (rowId, value) => {
        setTelcoRows(prev => prev.map(r => r.id === rowId ? { ...r, telco: value, package: null } : r));
        setPackages(prev => { const next = { ...prev }; delete next[rowId]; return next; });
        fetchPackage(value, rowId);
    };

    const handlePackageChange = (rowId, value) => {
        setTelcoRows(prev => prev.map(r => r.id === rowId ? { ...r, package: value } : r));
    };

    const handleAddTelcoRow = () => {
        if (!canAddTelcoRow) { message.warning("Đã chọn hết các nhà mạng khả dụng"); return; }
        setTelcoRows(prev => [...prev, { id: Date.now(), telco: null, package: null }]);
    };

    const handleRemoveTelcoRow = (rowId) => {
        setTelcoRows(prev => prev.filter(r => r.id !== rowId));
        setPackages(prev => { const next = { ...prev }; delete next[rowId]; return next; });
    };

    // ── Submit ─────────────────────────────────────────────────────────────────
    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            // const payload = {
            //     ...values,
            //     form_type: formType,
            //     promotion_payloads: telcoRows,
            //     form: formFields,
            //     oa_zns: zaloZnsEnabled ? values.oa_zns : null,
            //     template_id: zaloZnsEnabled ? values.template_id : null,
            //     zns: zaloZnsEnabled,
            //     // ...(zaloZnsEnabled && { zns_config: values.zns }),
            // };

            // const response = await rewardAPIWithErrorHandling.update(id, payload);

            const formData = new FormData();

            // ✅ FIX 1: Append file fields trực tiếp (File object) — không JSON.stringify
            if (values.logo instanceof File) formData.append("logo", values.logo);
            if (values.image_bg instanceof File) formData.append("image_bg", values.image_bg);

            // ✅ FIX 2: send_strategy "scheduled" -> "schedule" cho đúng với backend enum
            const sendStrategyValue = values.send_strategy === "scheduled" ? "schedule" : values.send_strategy;

            // ✅ FIX 3: Boolean zns phải append dưới dạng "1"/"0" hoặc "true"/"false"
            // Laravel/PHP đọc FormData boolean qua filter_var nên dùng "1"/"0" an toàn hơn
            formData.append("zns", zaloZnsEnabled ? "1" : "0");

            // ✅ FIX 4: Fields còn lại — phân biệt scalar vs object/array
            const scalarFields = {
                title: values.title,
                description: values.description,
                message: values.message,
                confirm: values.confirm,
                direct_url: values.direct_url,
                form_type: formType,
                promotion_type: values.promotion_type,
                limit_total: values.limit_total,
                limit_per_day: values.limit_per_day,
                send_strategy: sendStrategyValue,
                schedule_hours: values.schedule_hours,
                oaid: values.oaid,
                user_id: values.user_id,
                miniapp_id: values.miniapp_id,
                // template_id: values.template_id,
                // oa_zns chỉ gửi khi zaloZnsEnabled
                ...(zaloZnsEnabled && { oa_zns: values.oa_zns }),
                ...(zaloZnsEnabled && { template_id: values.template_id }),
            };

            Object.entries(scalarFields).forEach(([key, val]) => {
                // ✅ Bỏ qua undefined/null để backend dùng nullable rule
                if (val !== undefined && val !== null && val !== "") {
                    formData.append(key, val);
                }
            });

            // ✅ FIX 5: Array/object fields — JSON.stringify đúng chỗ
            formData.append("promotion_payloads", JSON.stringify(telcoRows));
            formData.append("form", JSON.stringify(formFields));

            // Debug — xóa khi production
            for (let [key, val] of formData.entries()) {
                console.log(`[FormData] ${key}:`, val);
            }

            const response = await rewardAPIWithErrorHandling.update(id, formData);

            if (response.data && response.data.success) {
                message.success("Cập nhật chương trình thành công!");
                // navigate("/survey");
                navigate(`/survey/${id}`);
            } else {
                throw new Error(response.data?.message || "Lỗi không xác định.");
            }
        } catch (err) {
            message.error(err.message || "Không thể cập nhật chương trình");
            console.error("Error updating:", err);
        } finally {
            setSubmitting(false);
        }
    };

    // ── Form View Columns ───────────────────────────────────────────────────────
    const formViewColumns = [
        {
            title: "Câu hỏi",
            dataIndex: "question",
            width: 220,
            render: (val, record) => (
                <Input
                    placeholder="Câu hỏi?"
                    value={val}
                    disabled={record.locked}
                    onChange={(e) => handleFieldChange(record.id, "question", e.target.value)}
                    size="small"
                    className={record.locked ? "bg-gray-100" : ""}
                />
            ),
        },
        {
            title: "Lưu ý",
            dataIndex: "note",
            width: 180,
            render: (val, record) => (
                <Input
                    placeholder="Lưu ý"
                    value={val}
                    onChange={(e) => handleFieldChange(record.id, "note", e.target.value)}
                    size="small"
                />
            ),
        },
        {
            title: "Name",
            dataIndex: "name",
            width: 150,
            render: (val, record) => (
                <Input
                    value={val}
                    disabled={record.locked}
                    onChange={(e) => handleFieldChange(record.id, "name", e.target.value)}
                    size="small"
                    className={record.locked ? "bg-gray-100" : ""}
                />
            ),
        },
        {
            title: "Kiểu dữ liệu",
            dataIndex: "dataType",
            width: 150,
            render: (val) => <Input value={val} disabled size="small" className="bg-gray-100" />,
        },
        {
            title: "Giá trị / Options",
            dataIndex: "options",
            render: (val, record) => {
                if (!OPTION_TYPES.includes(record.dataType)) {
                    return <Text type="secondary" className="text-xs">—</Text>;
                }
                return (
                    <OptionTagsEditor
                        options={record.options || []}
                        onChange={(opts) => handleFieldChange(record.id, "options", opts)}
                    />
                );
            },
        },
        {
            title: "Bắt buộc",
            dataIndex: "required",
            align: "center",
            width: 80,
            render: (val, record) => (
                <Checkbox
                    checked={val}
                    onChange={(e) => handleFieldChange(record.id, "required", e.target.checked)}
                />
            ),
        },
        {
            title: "Thao tác",
            align: "center",
            width: 70,
            render: (_, record) =>
                record.locked ? (
                    <Tooltip title="Trường mặc định, không thể xoá">
                        <Button type="text" icon={<MinusOutlined />} size="small" disabled />
                    </Tooltip>
                ) : (
                    <Button
                        type="text"
                        danger
                        icon={<MinusOutlined />}
                        onClick={() => handleRemoveField(record.id)}
                        size="small"
                    />
                ),
        },
    ];

    // ── Render ─────────────────────────────────────────────────────────────────
    if (pageLoading) {
        return (
            <div className="bg-gray-50 min-h-screen flex items-center justify-center">
                <Spin size="large" tip="Đang tải dữ liệu..." />
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen p-6">
            <Card className="shadow-sm">
                {/* Breadcrumb */}
                <Breadcrumb
                    separator=">"
                    className="mb-4"
                    items={[
                        { href: "/", title: (<span className="flex items-center gap-1"><HomeOutlined /> Trang chủ</span>) },
                        { href: "/survey", title: "Danh sách phiếu" },
                        { title: "Chỉnh sửa phiếu" },
                    ]}
                />

                {/* ── LOẠI PHIẾU ── */}
                <Card className="mb-4 shadow-sm" style={{ borderLeft: "4px solid #3b82f6" }} bodyStyle={{ padding: 20 }}>
                    <SectionHeader title="Loại phiếu" />
                    <Radio.Group
                        value={formType}
                        onChange={(e) => setFormType(e.target.value)}
                        buttonStyle="solid"
                        size="large"
                    >
                        <Radio.Button value="survey">📋 Khảo sát</Radio.Button>
                        <Radio.Button value="reward">🎁 Phần thưởng</Radio.Button>
                    </Radio.Group>
                    <div className="mt-3">
                        {formType === "survey" && (
                            <Text type="secondary" className="text-xs">
                                Chế độ <b>Khảo sát</b>: Thu thập thông tin, không cần thiết lập quà tặng.
                            </Text>
                        )}
                        {formType === "reward" && (
                            <Text type="secondary" className="text-xs">
                                Chế độ <b>Phần thưởng</b>: Kết hợp thu thập thông tin và tặng quà cho khách hàng.
                            </Text>
                        )}
                    </div>
                </Card>

                <Form form={form} layout="vertical" requiredMark={false}>

                    {/* ── CONTENT SECTION ── */}
                    <Card className="mb-4 shadow-sm" bodyStyle={{ padding: 24 }}>
                        <SectionHeader title="Content" />

                        <Row gutter={24} className="mb-6">
                            {/* <Col xs={24} md={12}>
                                <ImageUploadBox label="Logo" emoji="📌" name="logo" existingUrl={existingLogo} />
                            </Col>
                            <Col xs={24} md={12}>
                                <ImageUploadBox label="Background" emoji="🖼️" name="image_bg" existingUrl={existingBg} />
                            </Col> */}
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="logo"
                                    getValueFromEvent={(file) => file} // ✅ file được truyền từ onChange
                                >
                                    <ImageUploadBox label="Logo" emoji="📌" existingUrl={existingLogo}/>
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="image_bg"
                                    getValueFromEvent={(file) => file} // ✅
                                >
                                    <ImageUploadBox label="Background" emoji="🖼️" existingUrl={existingBg} />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider className="my-4" />

                        <Form.Item
                            label={<span>Tiêu đề <span className="text-red-500">*</span></span>}
                            name="title"
                            rules={[{ required: true, message: "Vui lòng nhập tiêu đề" }]}
                        >
                            <Input placeholder="Mời nhập thông tin" />
                        </Form.Item>

                        <Form.Item
                            label={<span>Mô tả <Text type="secondary" className="text-xs font-normal">(Nội dung chi tiết phiếu)</Text></span>}
                            name="description"
                        >
                            <TextArea rows={3} placeholder="Mời nhập thông tin" className="resize-none" />
                        </Form.Item>

                        <Form.Item
                            label={<span>Thông báo <Text type="secondary" className="text-xs font-normal">(Tin nhắn hiển thị khi phiếu gửi thành công)</Text></span>}
                            name="message"
                        >
                            <TextArea rows={3} placeholder="Mời nhập thông tin" className="resize-none" />
                        </Form.Item>

                        <Form.Item
                            label={<span>Nội dung xác nhận <Text type="secondary" className="text-xs font-normal">(Xác nhận phiếu sẽ được hiển thị nếu nội dung được nhập)</Text></span>}
                            name="confirm"
                        >
                            <TextArea rows={3} placeholder="Mời nhập thông tin" className="resize-none" />
                        </Form.Item>

                        <Form.Item
                            label={<span>URL Marketing <Text type="secondary" className="text-xs font-normal">(Chuyển trang sau khi phiếu gửi thành công)</Text></span>}
                            name="direct_url"
                        >
                            <Input placeholder="Mời nhập thông tin" />
                        </Form.Item>
                    </Card>

                    {/* ── ZALO SECTION ── */}
                    <Card className="mb-4 shadow-sm" bodyStyle={{ padding: 24 }}>
                        <SectionHeader title="ZALO" />

                        <Text className="block font-medium text-gray-700 mb-3 text-sm">
                            ZALO OA <Text type="secondary" className="text-xs font-normal">(Thông tin cài đặt oaID và userID)</Text>
                        </Text>

                        <Row gutter={12} className="mb-4">
                            <Col xs={24} md={8}>
                                {/* <Form.Item name={["oa_zns", "oaid"]} noStyle> */}
                                <Form.Item name="oaid" noStyle>
                                    <Input placeholder="OAID" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                {/* <Form.Item name={["oa_zns", "user_id"]} noStyle> */}
                                <Form.Item name="user_id" noStyle>
                                    <Input placeholder="USER_ID" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item name="miniapp_id" noStyle>
                                    <Input placeholder="MINIAPP_ID" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <div className="flex items-center gap-3 mb-3">
                            <Switch checked={zaloZnsEnabled} onChange={setZaloZnsEnabled} size="small" />
                            <Text className="text-sm font-medium text-gray-700">ZALO ZNS</Text>
                        </div>

                        {zaloZnsEnabled && (
                            <Row gutter={12}>
                                <Col xs={24} sm={6}>
                                    {/* <Form.Item name={["zns", "template_id"]} noStyle> */}
                                    <Form.Item name="template_id" noStyle>
                                        <Input placeholder="TemplateID" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={6}>
                                    {/* <Form.Item name={["zns", "brand_name"]} noStyle> */}
                                    <Form.Item name="oa_zns" noStyle>
                                        <Input placeholder="Thương hiệu (tên OA)" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                    </Card>

                    {/* ── CHƯƠNG TRÌNH QUÀ TẶNG ── */}
                    {formType === "reward" && (
                        <Card className="mb-4 shadow-sm" style={{ borderLeft: "4px solid #f59e0b" }} bodyStyle={{ padding: 24 }}>
                            <SectionHeader title="Chương trình quà tặng" />

                            <Form.Item
                                label={
                                    <span>
                                        Loại chương trình <span className="text-red-500">*</span>{" "}
                                        <Text type="secondary" className="text-xs font-normal">
                                            (Vui lòng tạo trường "email" trong trường hợp là thẻ "Game")
                                        </Text>
                                    </span>
                                }
                                name="promotion_type"
                                rules={[{ required: true, message: "Vui lòng chọn loại chương trình" }]}
                            >
                                <Select placeholder="-- Chọn loại chương trình --">
                                    <Option value="DATA">DATA</Option>
                                    <Option value="DIENTHOAI">Thẻ điện thoại</Option>
                                    <Option value="GAME">Thẻ game</Option>
                                </Select>
                            </Form.Item>

                            {/* Thiết lập nhà mạng */}
                            <div className="border rounded-lg p-4 mb-4">
                                <Text className="block font-medium text-gray-700 mb-3 text-sm">Thiết lập nhà mạng</Text>

                                {telcoRows.map((row) => {
                                    const usedTelcos = getUsedTelcos(row.id);
                                    return (
                                        <Row key={row.id} gutter={16} className="mb-3 items-center">
                                            <Col xs={24} md={11}>
                                                <Text className="block text-xs text-gray-600 mb-1">Nhà mạng <span className="text-red-500">*</span></Text>
                                                <Select
                                                    className="w-full"
                                                    placeholder="-- Chọn nhà mạng --"
                                                    value={row.telco}
                                                    loading={telcoLoading}
                                                    onChange={(val) => handleTelcoChange(row.id, val)}
                                                >
                                                    {telcos.map((t) => (
                                                        <Option
                                                            key={t.telco}
                                                            value={t.telco}
                                                            disabled={usedTelcos.includes(t.telco)}
                                                        >
                                                            {t.telco}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Col>
                                            <Col xs={24} md={11}>
                                                <Text className="block text-xs text-gray-600 mb-1">Gói cước <span className="text-red-500">*</span></Text>
                                                <Select
                                                    className="w-full"
                                                    placeholder="-- Chọn gói cước --"
                                                    value={row.package}
                                                    loading={!!packageLoading[row.id]}
                                                    disabled={!row.telco}
                                                    onChange={(val) => handlePackageChange(row.id, val)}
                                                >
                                                    {(packages[row.id] || []).map((p) => (
                                                        <Option key={p.package_name} value={p.package_name}>{p.package_name}</Option>
                                                    ))}
                                                </Select>
                                            </Col>
                                            <Col xs={24} md={2} className="flex justify-end pt-5">
                                                <Button
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => handleRemoveTelcoRow(row.id)}
                                                    disabled={telcoRows.length === 1}
                                                />
                                            </Col>
                                        </Row>
                                    );
                                })}

                                <Tooltip title={!canAddTelcoRow ? "Đã chọn hết các nhà mạng khả dụng" : ""}>
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={handleAddTelcoRow}
                                        disabled={!canAddTelcoRow}
                                        style={{
                                            backgroundColor: canAddTelcoRow ? "#3b82f6" : undefined,
                                            borderColor: canAddTelcoRow ? "#3b82f6" : undefined,
                                            borderRadius: 6,
                                        }}
                                    >
                                        Thêm nhà mạng
                                    </Button>
                                </Tooltip>
                            </div>

                            <Row gutter={24}>
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label={<span>Hạn lượng <span className="text-red-500">*</span></span>}
                                        name="limit_total"
                                        rules={[{ required: true, message: "Vui lòng nhập hạn lượng" }]}
                                    >
                                        <InputNumber className="w-full" placeholder="Nhập số lượng quà tặng (ví dụ: 1000)" min={0} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label={<span>Hạn lượng trong ngày <span className="text-red-500">*</span></span>}
                                        name="limit_per_day"
                                        rules={[{ required: true, message: "Vui lòng nhập hạn lượng trong ngày" }]}
                                    >
                                        <InputNumber className="w-full" placeholder="Nhập số lượng quà tặng trong ngày (ví dụ: 1000)" min={0} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label={
                                            <span>
                                                Thể lệ quà tặng <span className="text-red-500">*</span>{" "}
                                                <Text type="secondary" className="text-xs font-normal">
                                                    (Thiết lập thời gian nếu chọn "Đặt lịch")
                                                </Text>
                                            </span>
                                        }
                                        name="send_strategy"
                                        rules={[{ required: true, message: "Vui lòng chọn thể lệ" }]}
                                    >
                                        <Select onChange={(val) => setSendStrategy(val)}>
                                            <Option value="immediate">Gửi ngay</Option>
                                            <Option value="schedule">Đặt lịch</Option>
                                            <Option value="manual">Thủ công</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    {sendStrategy === "schedule" && (
                                        <Form.Item
                                            label={<span>Gửi sau bao lâu <span className="text-red-500">*</span></span>}
                                            name="schedule_hours"
                                            rules={[{ required: true, message: "Vui lòng chọn thời gian gửi" }]}
                                        >
                                            <Select placeholder="-- Chọn khoảng thời gian --">
                                                {DELAY_OPTIONS.map((d) => (
                                                    <Option key={d.value} value={d.value}>{d.label}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    )}
                                </Col>
                            </Row>
                        </Card>
                    )}

                    {/* ── FORM FIELDS ── */}
                    <Card className="mb-4 shadow-sm" bodyStyle={{ padding: 24 }}>
                        <SectionHeader title="Form fields" />

                        <div className="flex items-end gap-3 mb-2">
                            <div style={{ minWidth: 200 }}>
                                <Text className="block text-sm text-gray-600 mb-1">Kiểu dữ liệu</Text>
                                <Select
                                    className="w-full"
                                    placeholder="Chọn kiểu dữ liệu"
                                    value={newFieldType}
                                    onChange={setNewFieldType}
                                    style={{ width: 200 }}
                                >
                                    {DATA_TYPES.map((t) => (
                                        <Option key={t.value} value={t.value}>{t.label}</Option>
                                    ))}
                                </Select>
                            </div>

                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={handleAddField}
                                style={{ backgroundColor: brand.accent, borderColor: brand.accent, borderRadius: 6 }}
                            >
                                Thêm trường
                            </Button>
                        </div>

                        {OPTION_TYPES.includes(newFieldType) && (
                            <Text type="secondary" className="text-xs">
                                💡 Kiểu <b>{newFieldType}</b> cần nhập các giá trị options — sau khi thêm trường, nhập trực tiếp vào cột <b>Giá trị / Options</b> trong bảng bên dưới.
                            </Text>
                        )}
                    </Card>

                    {/* ── FORM VIEW ── */}
                    <Card className="mb-6 shadow-sm" bodyStyle={{ padding: 24 }}>
                        <div className="flex items-center justify-between mb-4">
                            <SectionHeader title="Form View" />
                            <Text type="secondary" className="text-xs">
                                🔒 Trường <b>name</b> và <b>phone</b> là mặc định, không thể xoá
                            </Text>
                        </div>

                        <Table
                            columns={formViewColumns}
                            dataSource={formFields}
                            rowKey="id"
                            pagination={false}
                            size="small"
                            bordered
                            scroll={{ x: "max-content" }}
                            locale={{ emptyText: "Chưa có trường nào" }}
                            rowClassName={(record) => record.locked ? "bg-blue-50" : ""}
                        />
                    </Card>

                    {/* ── ACTIONS ── */}
                    <div className="flex justify-end gap-3">
                        <Button
                            icon={<ArrowLeftOutlined />}
                            size="large"
                            style={{ borderRadius: 8 }}
                            onClick={() => navigate("/invoice-templates")}
                        >
                            Quay lại
                        </Button>
                        <Button
                            type="primary"
                            icon={<SaveOutlined />}
                            size="large"
                            loading={submitting}
                            onClick={handleSubmit}
                            style={{ backgroundColor: brand.accent, borderColor: brand.accent, borderRadius: 8, minWidth: 140 }}
                        >
                            Cập nhật
                        </Button>
                    </div>
                </Form>
            </Card>
        </div>
    );
}